import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doPostFiles, doDownload, doDeleteData } from './utils'

// const API_ROOT = 'http://localhost:9005/api'

//Progress ReportForm
export const getWithdrawRequestForm = (projectVersionId, requestId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}`
  return doGet(url)
}

export const updateWithdrawRequest = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}`
  return doPut(url, request)
}

export const getCPAForm = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/cpa`
  return doGet(url)
}

export const saveCPA = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/cpa`
  return doPostFiles(url, request)
}

export const deleteCPA = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/cpa`
  return doDelete(url)
}

export const downloadCPA = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/cpa/download`
  return doDownload(url)
}

export const getWidthdrawRequestApprove = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-approve`
  return doGet(url)
}

export const updateWidthdrawRequestApprove = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-approve/${requestId}`
  return doPut(url, request)
}

export const updateWidthdrawRequestSecureApprove = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/secure-approve/${requestId}`
  return doPut(url, request)
}

export const downloadWithdrawPaymentFile = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/files/${projectVersionId}/withdraw/payment/from/${requestId}`
  return doDownload(url)
}

export const withdrawSecureApproveSuccess = (referenceID) => {
  const url = `${API_ROOT}/progress/${referenceID}/withdraw-request/secure-approve`
  return doGet(url)
}

//secure-approve เบิกจ่ายหลายโครงการ
// export const widthdrawRequestSecureApproveMulti = (request, approveStatus) => {
//   const url = `${API_ROOT}/progress/multiple/withdraw-request/secure-approve?approveStatus=${approveStatus}`
//   return doPut(url, request)
// }

export const getExpendingForm = (projectVersionId, requestId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/attachment/${fileId}`
  return doGet(url)
}

export const saveExpending = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/attachment`
  return doPostFiles(url, request)
}

export const deleteExpending = (projectVersionId, requestId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/attachment/${fileId}`
  return doDelete(url)
}

export const downloadExpending = (projectVersionId, requestId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/attachment/${fileId}/download`
  return doDownload(url)
}

export const saveWidthdrawRequestProgress = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/with-progress-by-coordinator`
  return doPost(url, request)
}

export const updateWidthdrawRequestProgress = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request/${requestId}/with-progress-by-coordinator`
  return doPut(url, request)
}

export const getWithdrawRequestStatus = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-status`
  return doGet(url)
}

export const getWithdrawRequestBudget = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-budget/${requestId}`
  return doGet(url)
}

export const updateWithdrawRequestBudget = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-budget/${requestId}`
  return doPut(url, request)
}

export const updateWithdrawRequestBudgetWithPlanCode = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/withdraw-request-budget/${requestId}/multiple`
  return doPut(url, request)
}

// sub project api

export const getSubprojectWithdrawRequestForm = (projectVersionId, requestId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/withdraw-request/${requestId}`
  return doGet(url)
}

export const updateSubprojectWithdrawRequest = (projectVersionId, requestId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/withdraw-request/${requestId}`
  return doPut(url, request)
}

export const getSubprojectWithdrawAttachment = (projectVersionId, requestId, fileId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/withdraw-request/${requestId}/attachment/${fileId}`
  return doGet(url)
}

export const downloadSubprojectWithdrawAttachment = (projectVersionId, requestId, fileId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/withdraw-request/${requestId}/attachment/${fileId}/download`
  return doDownload(url)
}

export const getDownloadFileByPath = (filePath) => {
  const url = `${API_ROOT}/progress/file-download?filePath=${filePath}`
  return doDownload(url)
}

export const getVenderRequestForm = (projectVersionId, requestId) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/vendor-request/page/${requestId}`
  return doGet(url)
}

export const getRmsLocationDatas = () => {
  const url = `${API_ROOT}/portal/location/dropdown/json/rms-zipcode`
  return doGet(url)
}

export const saveRequestVendor = (projectVersionId, requestId, request, actionType) => {
  // http://localhost/api/progress/1/vendor-request/save/2/3
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/vendor-request/save/${requestId}/${actionType}`
  return doPost(url, request)
}

export const saveRequestVendorFile = (request, projectVersionId, requestId) => {
  // http://localhost/api/progress/33/vendor-request/save-file/22
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/vendor-request/save-file/${requestId}`
  return doPostFiles(url, request)
}

export const downRequestVendorFile = (fileId) => {
  // http://localhost/api/progress/vendor-request/download-file/sss
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/vendor-request/download-file/${fileId}`
  return doDownload(url)
}

export const deleteRequestVendorFile = (projectVersionId, requestId, fileId) => {
  // http://localhost/api/progress/111/vendor-request/delete-file/222/333
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/${projectVersionId}/vendor-request/delete-file/${requestId}/${fileId}`
  return doDeleteData(url)
}
